<script>
  import { onMount } from "svelte";
  import RadioButton from "./RadioButton.svelte";
  
  // Props using Svelte 5 runes
  let { 
    categories = [], 
    checkedProduct = $bindable(""), 
    anchorText = "" 
  } = $props();
  
  // State declaration
  let valueStore = $state(null);

  // Parse JSON data for categories
  let displayCats = $derived(categories.length > 0 ? JSON.parse(categories)[0] : []);
  
  // Sync checkedProduct with valueStore
  $effect(() => {
    if (checkedProduct && valueStore) {
      valueStore.value = checkedProduct;
    }
  });
  
  // Find selected category based on checkedProduct
  let selectedCat = $derived(displayCats.find(({ Id }) => Id === checkedProduct));

  onMount(() => {
    valueStore = document.getElementById("waterwise-specialists-selection");
  });
</script>

<fieldset class="wc-fieldset">
  <div
    class="flex flex-wrap gap-4 justify-center md:justify-between mt-0 pt-1"
  >
    {#each displayCats as category, index}
    {#snippet icon()}
    <img src={category.ImgUrl} alt={category.ImgAlt} />
  {/snippet}
  {#snippet text()}
  <p>{category.Name}</p>
  {/snippet}
    <RadioButton id={category.Id} first={index === 0} bind:show={checkedProduct} {text} {icon} />
    {/each}
  </div>
</fieldset>

{#if selectedCat}
  <p>
    <a
      class="btn-primary btn-mobile"
      href={selectedCat?.ProductLink}
      rel="noreferrer"
      target="_blank"
      title="External link - Smart Approved WaterMark website">{anchorText}</a
    >
  </p>
{/if}